import React, { useState } from "react";
import { useIntl } from "react-intl";
import { Button, Text, Space, Popover } from "react_reusable_components";

import QuickLinks from "../../components/QuickLinks";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import variables from "../../themes/base/styles/variables";

const popoverContentHeader = {
  display: variables.dFlex,
  alignItems: variables.alignCenter,
  justifyContent: variables.spaceBetween,
  width: variables.fullWidth,
  padding: variables.marginSmall,
};
const QuickLinksContainerStyle = {
  popupHeading: {
    fontSize: variables.fontSizeNormal,
    fontWeight: variables.fontWeightBold,
    color: variables.textDefault,
  },
  overlayStyle: {
    border: variables.popoverBorder,
    backgroundColor: variables.bodyBg,
  },
  linksIcon: {
    height: variables.menuIconHeight,
    width: variables.menuIconWidth,
  },
  popoverContentWrapper: {
    minWidth: variables.quickLinksPopupWidth,
    padding: variables.paddingXXXSmall,
  },
  iconButton: { all: variables.unset, cursor: "pointer" },
  closeIcon: {
    height: variables.closeIcon,
    width: variables.closeIcon,
    cursor: "pointer",
  },
};

export default function QuickLinksContainer() {
  const [open, setOpen] = useState(false);

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };
  const hide = () => {
    setOpen(false);
  };

  const intl = useIntl();

  return (
    <Popover
      placement="bottomLeft"
      arrow={false}
      trigger="click"
      overlayStyle={QuickLinksContainerStyle.overlayStyle}
      content={
        <Space
          size={0}
          style={QuickLinksContainerStyle.popoverContentWrapper}
          direction="vertical"
        >
          <Space size={0} style={popoverContentHeader}>
            <Text style={QuickLinksContainerStyle.popupHeading}>
              {getLocalizedMessage(intl, "dashboard.popup.heading")}
            </Text>
            <img
              src="icons/close.svg"
              style={QuickLinksContainerStyle.closeIcon}
              onClick={hide}
            />
          </Space>
          <QuickLinks hide={hide} />
        </Space>
      }
      open={open}
      onOpenChange={handleOpenChange}
    >
      <Button
        style={QuickLinksContainerStyle.iconButton}
        icon={
          <img
            alt={"icon"}
            style={QuickLinksContainerStyle.linksIcon}
            src={open ? "/icons/appsFilled.svg" : "/icons/apps.svg"}
          />
        }
      />
    </Popover>
  );
}
